import { Outlet } from "react-router-dom"

export default function VehiclePage() {
  return (
    <main className="vehicle-page">
      <Outlet />
    </main>
  )
}
